import { getLocationLabel } from '../i18n';

// 日付フォーマット（ja: 2025/7/16(水), en: 2025/7/16(Mon)）
export const formatDateJapanese = (dateString, language = 'ja') => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = language === 'en'
        ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()]
        : ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
    return `${year}/${month}/${day}(${dayOfWeek})`;
};

// 曜日を日本語に変換
export const getDayOfWeekJapanese = (dayOfWeekEng) => {
    const dayMap = {
        'Mon': '月',
        'Tue': '火', 
        'Wed': '水',
        'Thu': '木',
        'Fri': '金',
        'Sat': '土',
        'Sun': '日'
    };
    return dayMap[dayOfWeekEng] || dayOfWeekEng;
};

// 短縮日付フォーマット（7/16）
export const formatDateShort = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}/${day}`;
};

// 場所名を日本語で表示
export const getLocationDisplayName = (location, language = 'ja') => {
    return getLocationLabel(location, language);
};
